import gql from 'graphql-tag';
const SHIFTY_TARGETS_ACTIVITY_FRAGMENT = gql `
  fragment ShiftyTargetsActivityFragment on ShiftyTargetsActivity {
    rounds {
      answer
      id
      shiftKey
      repetitions
    }
  }
`;
export default SHIFTY_TARGETS_ACTIVITY_FRAGMENT;
